import { DataPeriod } from 'interfaces/global/globalInterfaces';

const NON_ENDED_PERIOD_STATUSES = ['active', 'planned'] as const;

type NonEndedPeriodStatus = (typeof NON_ENDED_PERIOD_STATUSES)[number];

const isNonEndedPeriodStatus = (status: string | undefined): status is NonEndedPeriodStatus =>
  NON_ENDED_PERIOD_STATUSES.includes(status as NonEndedPeriodStatus);

export const getNonEndedServicePeriodUuids = (periods: DataPeriod[] | null | undefined): string => {
  if (!periods?.length) {
    return '';
  }

  return periods
    .filter((period) => isNonEndedPeriodStatus(period.status?.value))
    .map((period) => period.uuid)
    .join(',');
};
